const Card = {
  baseStyle: {
    backgroundColor: 'brand.primary',
    padding: '4',
    color: 'white',
  },
};

export default Card;
